import { useEffect } from "react";
import { toast } from "react-toastify";

export function logout() {
  localStorage.clear();
  toast.success("Logged Out");
  localStorage.setItem("isLogged", "");
  window.location.href = "/";
}

function Logout(props) {
  useEffect(() => {
    logout();
  }, []);
}
export default Logout;
